<template>
  <v-app>
    <Toolbar></Toolbar>
    <v-main>
      <v-container fluid>
        <v-layout justify-center align-center>
          <v-flex xs12 lg10>
            <router-view></router-view>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    <v-card height='172' flat>
      <v-footer
        absolute
        color='primary'
        class='font-weight-medium'
        elevation='0'
        
      >
        <v-col
          class='text-center'
          cols='12'
        >
          <v-img
              src='@/assets/Arup_Black.png'
              height='72px'
              contain
          ></v-img>
          <v-card-text>produced by <v-chip small outlined color='secondary'>BL Futures</v-chip> and <v-chip small outlined color='secondary'>Infrastructure London</v-chip> for <strong>Arup</strong> (2021)</v-card-text>
        </v-col>
      </v-footer>
    </v-card>
  </v-app>
</template>

<script>
import Toolbar from '@/components/Toolbar';


export default {
  name: 'App',

  components: {
    Toolbar,
  },

  data: () => ({
  
    //
  }),

 
}
</script>

